import axios from 'axios';

// رابط السيرفر: من متغير بيئة في الإنتاج، ولوكال هوست في التطوير
// ⚠️ كان هنا رابط خطأ بيشاور على دومين الفرونت إند نفسه بدل الباك اند،
// عشان كده كانت كل الريكوستات فاشلة وبتطلع "تأكد من اتصالك بالسيرفر".
// لازم تحط رابط الباك اند الحقيقي بعد ما تعمله ديبلوي في REACT_APP_API_URL.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// بنحط التوكن أوتوماتيك في كل ريكوست لو المستخدم مسجل دخول
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// لو التوكن انتهى أو مش صالح، نرجّع المستخدم لصفحة اللوجين تلقائياً
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
